import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { dispatch, RootState, select, store } from '../../store'
import { getLectureStatus, LectureStatus } from '../../utils'
import Avatar from '../Avatar'
import { CardBody, CardContainer, CardTag, CardTitle } from '../Card'
import Icon from '../Icon'
import Image from '../Image'
import styles from './lecture-item.scss'

const cx = classnames.bind(styles)

interface IProps
  extends React.HTMLProps<HTMLDivElement>,
    ReturnType<typeof mapState> {
  lectureId: string
}
class LectureItem extends React.Component<IProps> {
  public state = {
    insightIds: [],
    views: 0
  }
  public componentDidMount = () => {
    const { lectureId } = this.props
    dispatch.stats.fetchStats(lectureId)
    firebase
      .firestore()
      .collection('pageviews')
      .doc(`_lectures_${lectureId}`)
      .get()
      .then(snap => {
        this.setState({ views: snap.exists ? snap.get('count') : 0 })
      })
  }
  public componentWillMount = () => {
    this.getInsightsFromProps(this.props)
  }
  public getInsightsFromProps = (nextProps: IProps): null => {
    const rootState = store.getState()
    const { lectureId } = nextProps
    const lecture = select.lectures.getById(rootState, lectureId)
    const insightIdsLevel3 = lecture
      ? lecture.units.map(unit =>
          unit.chapters.map(chapter => chapter.insightIds)
        )
      : []
    const insightIdsLevel2 =
      insightIdsLevel3.length > 0
        ? insightIdsLevel3.reduce((prev, curr) => prev.concat(curr))
        : []
    const insightIds =
      insightIdsLevel2.length > 0
        ? insightIdsLevel2.reduce((prev, curr) => prev.concat(curr))
        : []
    this.setState({ insightIds })
    dispatch.insights.fetchInsights(insightIds)
    return null
  }
  public renderAvatar = (lecture: ILecture) => {
    return lecture.speakerIds.length > 1 ? (
      <div className={cx('lecture-item__multiMentor')}>
        {lecture ? (
          <Avatar className={cx('avatar')} userId={lecture.speakerIds[0]} />
        ) : null}
        {lecture ? (
          <Avatar className={cx('avatar')} userId={lecture.speakerIds[1]} />
        ) : null}
      </div>
    ) : (
      <Avatar className={cx('avatar')} userId={lecture.speakerIds[0]} />
    )
  }

  public render() {
    const rootState = store.getState()
    const { lectureId, className, stats } = this.props
    const lecture = select.lectures.getById(rootState, lectureId)
    const speakers = lecture
      ? lecture.speakerIds.map(speakerId =>
          select.users.getById(rootState, speakerId)
        )
      : []
    const participants = select.participants.getByLectureId(
      rootState,
      lectureId
    )
    const lectureStatus = getLectureStatus(lecture)
    return (
      <div className={cx('lecture-item', className)}>
        <div className={cx('lecture-item__mentor')}>
          {lecture ? this.renderAvatar(lecture) : null}
          <div>
            <h5 className={cx('lecture-item__mentor-name')}>
              {speakers
                .map(speaker => (speaker ? speaker.fullName : 'NA'))
                .join('/')}
            </h5>
            <p className={cx('lecture-item__mentor-title')}>
              {speakers
                .map(speaker => (speaker ? speaker.title : 'NA'))
                .join('/')}
            </p>
          </div>
        </div>
        <Link to={`/lectures/${lectureId}`}>
          <CardContainer className={cx('card')}>
            <Image
              className={cx('image-container')}
              ratio={'16-9'}
              source={lecture ? lecture.photoURL : ''}
            />
            <CardBody className={cx('card__body')}>
              <CardTitle className={cx('card__title')}>
                {lecture ? lecture.title : 'N/A'}
                {lecture && lecture.status === 'pending' ? ' - 審核中' : null}
              </CardTitle>
              <div className={cx('lecture-item__sort')}>
                {lecture
                  ? lecture.tags.map(tag => (
                      <span key={tag} className={cx('lecture-item__sort-item')}>
                        {tag}
                      </span>
                    ))
                  : null}
              </div>
              {/* <div className="rate lecture-item__rate">
              <div className="stars">
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <div className="lecture-item__rate-amount">來自<span>304</span>人</div>
            </div> */}
              <div className={cx('lecture-item__data')}>
                <div className={cx('lecture-item__data-item')}>
                  <Icon type="focus" />
                  <span className={cx('amount')}>
                    {this.state.views}
                    {/* {lecture
                      ? Math.round(Math.log(Date.now()) * 50) +
                        lecture.description.length * 4 +
                        lecture.title.length * 3
                      : 1 * Math.floor(Math.random() * 3230)} */}
                  </span>
                  <Icon type="user" />
                  <span className={cx('amount')}>
                    {participants ? participants.length : 0}
                  </span>
                </div>
                {/* {
                  lecture && lecture.soldAt.toMillis() >= firebase.firestore.Timestamp.now().toMillis() ? (
                    <div className={cx('lecture-item__data-item')}>
                      <Icon type="fundraising-time" />
                      <span className={cx('amount')}>剩餘 {
                        ((lecture.soldAt.toMillis() - firebase.firestore.Timestamp.now().toMillis()) / 86400 / 1000).toFixed(0)
                      } 天</span>
                    </div>
                  ) : null
                } */}
              </div>
              {lecture ? (
                lectureStatus === LectureStatus.Fundraising ? (
                  <div
                    className={cx(
                      'lecture-item__price',
                      'lecture-item__price-fundraising'
                    )}
                  >
                    {lecture &&
                    lecture.soldAt.toMillis() >=
                      firebase.firestore.Timestamp.now().toMillis() ? (
                      <div className={cx('lecture-itme__status-flex-box')}>
                        <div className={cx('lecture-itme__status-flex-item')}>
                          <Icon
                            type="fundraising-day"
                            className={cx('lecture-itme__icon-fundraising-day')}
                          />
                          <span className={cx('lecture-itme__success')}>
                            預購剩餘{' '}
                            {(
                              (lecture.soldAt.toMillis() -
                                firebase.firestore.Timestamp.now().toMillis()) /
                              86400 /
                              1000
                            ).toFixed(0)}{' '}
                            天
                          </span>
                        </div>
                        <div
                          className={cx('lecture-itme__status-box-flex-end')}
                        >
                          <span className={cx('origin')}>
                            NT$
                            {lecture.listPrice}
                          </span>
                          <span className={cx('discount')}>
                            NT$
                            {lecture.earlyPrice}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className={cx('lecture-itme__status-box-flex-end')}>
                        <span className={cx('origin')}>
                          NT$
                          {lecture.listPrice}
                        </span>
                        <span className={cx('discount')}>
                          NT$
                          {lecture.earlyPrice}
                        </span>
                      </div>
                    )}
                  </div>
                ) : lectureStatus === LectureStatus.Success ? (
                  <div
                    className={cx(
                      'lecture-item__price',
                      'lecture-item__price-success'
                    )}
                  >
                    <div className={cx('lecture-itme__status-flex-box')}>
                      <div className={cx('lecture-itme__status-flex-item')}>
                        <Icon
                          type="date"
                          className={cx('lecture-itme__icon-date')}
                        />
                        <span className={cx('lecture-itme__success')}>
                          即將開講
                        </span>
                      </div>
                      <span className={cx('discount')}>
                        NT$
                        {lecture.listPrice}
                      </span>
                    </div>
                  </div>
                ) : lectureStatus === LectureStatus.Processing ? (
                  <div
                    className={cx(
                      'lecture-item__price',
                      'lecture-item__price-processing'
                    )}
                  >
                    <div className={cx('lecture-itme__status-flex-box')}>
                      <div className={cx('lecture-itme__status-flex-item')}>
                        <Icon
                          type="message"
                          className={cx('lecture-itme__icon-message')}
                        />
                        <span className={cx('lecture-item__processing')}>
                          熱烈討論中
                        </span>
                      </div>
                      <span className={cx('discount')}>
                        NT$
                        {lecture.listPrice}
                      </span>
                    </div>
                  </div>
                ) : lectureStatus === LectureStatus.Finish ? (
                  <div
                    className={cx(
                      'lecture-item__price',
                      'lecture-item__price-finish'
                    )}
                  >
                    <div className={cx('lecture-itme__status-flex-box')}>
                      <div className={cx('lecture-itme__status-flex-item')}>
                        <Icon
                          type="message"
                          className={cx('lecture-itme__icon-message')}
                        />
                        <span className={cx('lecture-item__finish')}>
                          {stats[lectureId]
                            ? stats[lectureId].replyIds.length
                            : '---'}
                          則互動
                        </span>
                      </div>
                      <span className={cx('discount')}>
                        NT$
                        {lecture.listPrice}
                      </span>
                    </div>
                  </div>
                ) : null
              ) : null}
            </CardBody>
            <CardTag
              className={cx('lecture-item__tag', {
                'lecture-item__tag-fundraising':
                  lectureStatus === LectureStatus.Fundraising,
                'lecture-item__tag-success':
                  lectureStatus === LectureStatus.Success,
                'lecture-item__tag-processing':
                  lectureStatus === LectureStatus.Processing,
                'lecture-item__tag-finish':
                  lectureStatus === LectureStatus.Finish
              })}
            >
              {lectureStatus}
            </CardTag>
          </CardContainer>
        </Link>
      </div>
    )
  }
}

const mapState = ({
  lectures,
  users,
  participants,
  insights,
  stats
}: RootState) => ({
  stats,
  lectures,
  users,
  participants,
  insights
})

export default connect(mapState)(LectureItem)



// WEBPACK FOOTER //
// ./src/components/LectureItem/index.tsx